import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import { useCallback, useMemo } from 'react';
import useSWR, { Arguments, mutate } from 'swr';

export interface WatcherAddressInfo {
  id: number;
  symbol: string;
  account: number;
  address: string;
  label: string;
  delegated: string;
  rewards: string;
  dateAdded: number;
}

/**
 * useWatcherAddressList
 */
export default function useWatcherAddressList(
  data: { symbols: string[] } = { symbols: [] }
) {
  return useSWR(
    ['/api/v1/watcher/address/list', data],
    ([url, data]) =>
      request.post<ResponseObject<WatcherAddressInfo[]>>(url, data),
    {
      refreshInterval: 12_000,
      keepPreviousData: true,
    }
  );
}
export function useWatcherAddressInfo(address?: string) {
  const { data } = useWatcherAddressList();
  return useMemo(
    () => data?.data.data?.find(item => item.address === address),
    [data, address]
  );
}

export function useMutateWatcherAddressList() {
  return useCallback(
    () =>
      mutate(
        (key: Arguments) =>
          Array.isArray(key) && key.includes('/api/v1/watcher/address/list')
      ),
    []
  );
}
